import { Component, inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { TipoParametro } from 'src/app/features/data-visualization/reports/models/parametro';
import { HelperFunctions } from 'src/app/util/util-functions';
import { ModalService } from '../../services/modal.service';
import { CustomInput } from './custom-input';

@Component({
    selector: 'app-type-input',
    templateUrl: './type-input.component.html',
    styleUrls: ['./type-input.component.scss'],
    standalone: false
})
export class TypeInputComponent {
  @Input() control: FormControl;
  @Input() input: CustomInput;
  parameterType: typeof TipoParametro = TipoParametro;
  public modalService = inject(ModalService);

  faUpload = faUpload;

  /**
   * A function that checks if the control is invalid
   * @returns {boolean}
   */
  hasErrors(): boolean {
    return HelperFunctions.controlIsInvalid(this.control);
  }

  loadClientData(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    const reader = new FileReader();
    const pattern = new RegExp(/^[0-9.]+$/);
    let errorData = '';
    reader.onload = () => {
      const text = reader.result as string;
      const lines = text.split(/\r?\n/).filter(line => line.trim() !== "");
      const values = lines.slice(1).map(line => line.trim());
      for (const element of values) {
        if (!pattern.test(element)) {
          errorData += `${element}\n`;
        }
      }
      if (errorData !== '') {
        this.modalService.getConfirmacionModal({
          message: `Revise los datos ingresados, deben ser numéricos y no contener caracteres especiales:\n${errorData}\n`,
          confirmTitle: 'Cerrar',
          isError: true,
        });
        return;
      }
      const result = values.join(",");
      this.control.setValue(result);
    };
    reader.readAsText(file);
  }
}